import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import { Modal, TextInput } from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { useField } from 'react-final-form';
import { LocationSelectField, UniformSelectField } from '../';

const Label = styled.div`
  font-weight: 500;
  margin-bottom: 5px;
`;

const SubLabel = styled.label`
  font-weight: 400;
  margin-bottom: 5px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 25px;
`;

const MeetingSpot = styled.div`
  margin-top: 15px;
`;

const OnsiteContact = styled.div`
  display: flex;
  gap: 15px;
  width: 100%;
  margin-top: 15px;

  > div {
    flex: 1;
  }
`;

export const InstructionsModal = ({
  onClose,
  includeLocation = false,
  includeUniform = false,
  includePoNumber = false,
  enableLocationChange = false,
  enableUniformChange = false,
  title = 'orderDetailsModalEditInstructions'
}) => {
  const {
    input: { value: formLocationId, onChange: setFormLocationId }
  } = useField('locationId');

  const {
    input: { value: formUniformId, onChange: setFormUniformId }
  } = useField('uniforms');

  const {
    input: { value: formPoNumber, onChange: setFormPoNumber }
  } = useField('poNumber');

  const {
    input: { value: formMeetingSpot, onChange: setFormMeetingSpot }
  } = useField('meetingSpot');

  const {
    input: { value: formOnsiteContactName, onChange: setFormOnsiteContactName }
  } = useField('onsiteContactName');

  const {
    input: { value: formOnsiteContactPhone, onChange: setFormOnsiteContactPhone }
  } = useField('onsiteContactPhone');

  const { t } = useContext(ConfigContext);
  const [uniformId, setUniformId] = useState(formUniformId);
  const [poNumber, setPoNumber] = useState(formPoNumber);
  const [locationId, setLocationId] = useState(formLocationId);
  const [meetingSpot, setMeetingSpot] = useState(formMeetingSpot);
  const [onsiteContactName, setOnsiteContactName] = useState(formOnsiteContactName);
  const [onsiteContactPhone, setOnsiteContactPhone] = useState(formOnsiteContactPhone);

  const handleSubmit = () => {
    if (includeLocation) {
      setFormLocationId(locationId);
    }
    if (includeUniform) {
      setFormUniformId(uniformId);
    }
    if (includePoNumber) {
      setFormPoNumber(poNumber);
    }
    setFormMeetingSpot(meetingSpot);
    setFormOnsiteContactName(onsiteContactName);
    setFormOnsiteContactPhone(onsiteContactPhone);
    onClose();
  };

  return (
    <Modal size="medium" onClose={onClose} title={t(title)} onConfirm={handleSubmit} usePortal>
      <Content>
        {includeLocation && (
          <div>
            <Label>{t('location')}</Label>
            <LocationSelectField
              onChange={setLocationId}
              placeholder={t('eventLocation')}
              hideTitle
              value={locationId}
              disabled={!enableLocationChange}
            />
          </div>
        )}

        {includeUniform && (
          <div>
            <Label>{t('uniform')}</Label>
            <UniformSelectField
              clearable={false}
              disabled={!enableUniformChange}
              name="uniforms"
              onChange={setUniformId}
              value={uniformId}
              placeholder={t('search')}
              hideTitle
            />
          </div>
        )}

        {includePoNumber && (
          <div>
            <Label>{t('poNumber')}</Label>
            <TextInput value={poNumber} onChange={setPoNumber} />
          </div>
        )}

        <div>
          <Label>{t('onsiteInformation')}</Label>
          <MeetingSpot>
            <SubLabel>{t('meetingSpot')}</SubLabel>
            <TextInput value={meetingSpot} onChange={setMeetingSpot} />
          </MeetingSpot>
          <OnsiteContact>
            <div>
              <SubLabel>{t('onsiteContact')}</SubLabel>
              <TextInput value={onsiteContactName} onChange={setOnsiteContactName} />
            </div>
            <div>
              <SubLabel>{t('onsiteContactPhone')}</SubLabel>
              <TextInput value={onsiteContactPhone} onChange={setOnsiteContactPhone} />
            </div>
          </OnsiteContact>
        </div>
      </Content>
    </Modal>
  );
};
